import { useIntl } from 'react-intl';
import { Outlet, useParams } from 'react-router-dom';

import MainLayout from 'src/components/layout/MainLayout';
import Tab from 'src/components/navigation/Tab';
import TabRow from 'src/components/navigation/TabRow';
import payStationsMessages from 'src/features/payStations/utils/messages';

const SinglePayStationLayout = () => {
    const { formatMessage } = useIntl();
    const { payStationId } = useParams();
    return (
        <MainLayout>
            <TabRow>
                <Tab end to={`/pay-stations/${payStationId}`}>
                    {formatMessage(payStationsMessages.info)}
                </Tab>
                <Tab to={`/pay-stations/${payStationId}/logs`}>{formatMessage(payStationsMessages.logs)}</Tab>
                <Tab end to={`/pay-stations/${payStationId}/heart-beats`}>
                    {formatMessage(payStationsMessages.heartBeats)}
                </Tab>
            </TabRow>
            <Outlet />
        </MainLayout>
    );
};

export default SinglePayStationLayout;
